module.exports = {
	"version": "0.17.0-alpha"
};


//////////////////
// WEBPACK FOOTER
// ../~/web3/lib/version.json
// module id = 467
// module chunks = 0